import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import GlobalDiamondReportService from "../../services/reports-globalDiamond-service";
import { useSelector } from "react-redux";
import moment from "moment";
import { Spin } from "antd";
import Chart from "react-google-charts";
import { chartColors } from "../reports/colors";

const DiamondColorSearchesComp = ({
  globalDiamonds,
  isApplyFilter,
  mainForDealer,
}) => {
  const { t } = useTranslation();
  /*React Binding Starts*/
  const [dealerId, setDealerId] = useState();
  const [forDealer, setForDealer] = useState("");
  const loginDetials = useSelector((state) => state.loginReducer);
  const [LoadChartReportsLoading, setLoadChartReportsLoading] = useState(false);
  const [diamondColorSearchesLabels, setdiamondColorSearchesLabels] = useState(
    []
  );
  const [DiamondColorSearchesList, setDiamondColorSearchesList] = useState([]);
  const [DiamondColorYAxisList, setDiamondColorYAxisList] = useState([]);
  const [totalValueForPercentage, setTotalValueForPercentage] = useState(0);
  const [TooltipPercentage, setTooltipPercentage] = useState("");
  const [key, setKey] = useState(true);

  // New states for processed chart data
  const [chartData, setChartData] = useState([]);
  const [colorData, setColorData] = useState([]);

  // Configuration
  const MAX_ENTRIES = 15; // Maximum entries to show
  /*React Binding Ends*/

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleLoadChartReports(
            loginDetials.loginDetials.responseData.dealerId,
            mainForDealer
          );
        }
      }
    }
  }, [isApplyFilter]);

  // Process chart data with max entries limit
  const processChartData = (searchesList) => {
    if (!searchesList?.length) {
      return { chartData: [], colors: [] };
    }

    // Filter out zero values and sort by count (descending)
    const filteredData = searchesList.filter((item) => item.CNT > 0);
    const sortedData = [...filteredData].sort((a, b) => b.CNT - a.CNT);

    // Apply max entries limit
    const topData = sortedData.slice(0, MAX_ENTRIES);
    const remainingData = sortedData.slice(MAX_ENTRIES);

    // Calculate "Others" if needed
    const othersValue = remainingData.reduce((sum, item) => sum + item.CNT, 0);
    if (othersValue > 0 && remainingData.length > 0) {
      topData.push({
        Color: t("Others"),
        CNT: othersValue,
        isOthers: true,
      });
    }

    // Calculate total for percentages
    const total = topData.reduce((sum, item) => sum + item.CNT, 0);

    // Prepare chart data
    const processedChartData = [["Color", "Count"]];
    const colors = [];

    topData.forEach((item, index) => {
      const percentage = total > 0 ? ((item.CNT / total) * 100).toFixed(1) : 0;
      const color = item.isOthers
        ? "#CCCCCC"
        : chartColors[index % chartColors.length];
      colors.push(color);

      processedChartData.push([`${item.Color} (${percentage}%)`, item.CNT]);
    });

    return { chartData: processedChartData, colors };
  };

  /*API Binding Starts*/
  const handleCheckDealermembers = (id) => {
    try {
      let inputData = {
        dealerID: id,
      };

      GlobalDiamondReportService.CheckDealermembers(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var forDealer = responseData.forDealer;
          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              setForDealer(forDealer);
            } else {
              setForDealer("");
            }
            handleLoadChartReports(id, forDealer);
          } else {
            setForDealer("");
          }
        })
        .catch((error) => {
          setForDealer("");
        });
    } catch (error) {
      setForDealer("");
    }
  };

  const handleLoadChartReports = (dealerId, forDealer) => {
    try {
      let inputData = {
        dealerID: dealerId.toString(),
        forDealer: forDealer ? forDealer.toString() : "",
        fromDate: globalDiamonds.dataRangeFrom
          ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
          : "2020-08-17",
        toDate: globalDiamonds.dataRangeTo
          ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        retailerIds: globalDiamonds.retailerIds.toString(),
        vendorIds: globalDiamonds.vendorIds.toString(),
        selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
        type: "",
        reportName: "ExtDiamondChrt",
      };
      setLoadChartReportsLoading(true);

      GlobalDiamondReportService.LoadChartReports(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var DiamondColorSearchesList = responseData.DiamondColorSearches;
          setLoadChartReportsLoading(false);
          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              setDiamondColorSearchesList(DiamondColorSearchesList);
              var DiamondColorSearchesLabelArr = DiamondColorSearchesList.map(
                (item) => {
                  return item.Color;
                }
              );
              setdiamondColorSearchesLabels(DiamondColorSearchesLabelArr);
              var DiamondColorYAxisList = DiamondColorSearchesList.map(
                (item) => {
                  return item.CNT;
                }
              );
              setDiamondColorYAxisList(DiamondColorYAxisList);
              var totalValueForPercentage = DiamondColorYAxisList.reduce(
                (a, b) => a + b,
                0
              );
              setTotalValueForPercentage(totalValueForPercentage);

              // Process data with max entries limit
              const { chartData: processedData, colors } = processChartData(
                DiamondColorSearchesList
              );
              setChartData(processedData);
              setColorData(colors);

              setKey(!key);
            }
          } else {
            setDiamondColorSearchesList([]);
            setDiamondColorYAxisList([]);
            setChartData([]);
            setColorData([]);
          }
        })
        .catch((error) => {
          setDiamondColorSearchesList([]);
          setDiamondColorYAxisList([]);
          setChartData([]);
          setColorData([]);
          setLoadChartReportsLoading(false);
          setdiamondColorSearchesLabels([]);
        });
    } catch (error) {
      setDiamondColorSearchesList([]);
      setDiamondColorYAxisList([]);
      setChartData([]);
      setColorData([]);
      setLoadChartReportsLoading(false);
      setdiamondColorSearchesLabels([]);
    }
  };
  /*API Binding Ends*/

  const options = {
    is3D: true,
    legend: {
      position: "none",
    },
    chartArea: {
      width: "100%",
      height: "100%",
      left: window.innerWidth > 500 ? 50 : 10,
      top: 50,
      bottom: 50,
    },
    pieSliceText: "percentage",
    tooltip: {
      text: "percentage",
      textStyle: {
        fontSize: 14,
      },
    },
    colors: colorData,
    sliceVisibilityThreshold: 0.01,
  };

  // Custom Legend Component
  const CustomLegend = () => {
    if (!chartData.length || chartData.length <= 1) return null;

    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          marginBottom: "10px",
        }}
      >
        {chartData.slice(1).map((row, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              margin: "4px 8px",
              fontSize: "13px",
              fontWeight: "500",
            }}
          >
            <div
              style={{
                width: "14px",
                height: "14px",
                backgroundColor: colorData[index],
                marginRight: "6px",
                borderRadius: "3px",
              }}
            ></div>
            {row[0].replace(/\s*\([^)]*\)\s*/g, "")} ({row[1]})
          </div>
        ))}
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className="col-lg-12 mt-4">
        <label>
          <b> {t("Diamond Color Searches")} </b>
        </label>
        <div
          className="chart__section"
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Spin spinning={LoadChartReportsLoading} size="large">
            {chartData.length > 1 ? (
              <>
                {/* Custom Legend */}
                <CustomLegend />

                {/* Centered Pie Chart */}
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <div id="pdf-content">
                    <Chart
                      chartType="PieChart"
                      width={window.innerWidth > 500 ? 800 : 320}
                      height={window.innerWidth > 500 ? 500 : 320}
                      data={chartData}
                      options={options}
                    />
                  </div>
                </div>
              </>
            ) : (
              <div className="no-report-render">
                <div className="desc-space">
                  <h4 className="text-center">{t("No Data Found")}</h4>
                </div>
              </div>
            )}
          </Spin>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DiamondColorSearchesComp;
